let view = null;

export default {
	namespace: 'template-impact',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ImpactView } = await import(
			/* webpackChunkName: "impact-view" */ '../../templates/ImpactView'
		);
		view = new ImpactView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
